import React, { useEffect } from 'react';
import { RecordsTable } from 'dyl-components';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './index.scss';
import SessionTableHeader from './SessionTableHeader';
import SessionRow from './SessionRow';
import { useDispatch, useSelector } from 'react-redux';
import campaignSessionSummaryActions from 'actions/campaign_session_summary';

const DialerSessionSummary = () => {
    const { id } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const sortDirection = params.get('order') === 'asc';
    const root = `/campaigns/${id}/session-summary/dialer`;

    const onToggleSort = () => {
        const query = new URLSearchParams(params);
        if (sortDirection) {
            query.delete('order');
        } else {
            query.set('order', 'asc');
        }
        const query_string = query.toString();
        navigate(`${root}${query_string ? `?${query_string}` : ''}`);
    };

    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`${root}${query_string ? `?${query_string}` : ''}`);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        const { start, end, order, page } = Object.fromEntries(params);
        dispatch(campaignSessionSummaryActions.readDialerSessionSummary(id, {
            start_time: start || undefined,
            end_time: end || undefined,
            order, 
            page
        }));
    }, [id, params, dispatch]);

    const { sessionSummary, isReadingSessionSummary, sessionSummaryCount } = useSelector(state => ({
        sessionSummary: state.campaign_session_summary.sessionSummary,
        isReadingSessionSummary: state.campaign_session_summary.isReadingSessionSummary,
        sessionSummaryCount: state.campaign_session_summary.sessionSummaryCount || 0
    }));

    const isEmpty = sessionSummaryCount === 0;
    return (
        <RecordsTable
            tableBodyClassName='DialerSessionsTable'
            isTableLoading={isReadingSessionSummary}
            isSearchResultEmpty={isEmpty && (params.get('start') || params.get('end'))}
            isTableEmpty={isEmpty && !(params.get('start') || params.get('end'))}
            TableHeader={<SessionTableHeader root={root} sortDirection={sortDirection} onToggleSort={onToggleSort} />}
            TableRows={sessionSummary.map((session) => (
                <SessionRow
                    key={session.id}
                    session={session}
                />
            ))}
            recordsCount={sessionSummaryCount}
            activePage={Number(params.get('page')) || 1}
            onPageChange={onPageChange}
            recordsName='Dialer Sessions'
            emptyListTitle='No Dialer Sessions Found'
            emptySubtitle=' '
        />
    );
};

export default DialerSessionSummary;

